import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsInputs from "../../../src/SubTabsInputs.js";
import { isSuperAdmin } from "./../../helpers/user.js";
import { Blocks } from 'react-loader-spinner'
import { saveAs } from 'file-saver';
import axiosService from '../../helpers/axios';
import { SatelliteContext } from '../../context/SatelliteContext';
import { getSatelliteApiParam, satellitePayloadValue, displaySatellite } from '../../helpers/satellite';


  export default class InputsForecasts extends Component{
    static contextType = SatelliteContext; 

    constructor(props){
      super(props);

      this.state={
          forecasts:[],
          modalTitle:"",
          forecastid:0,
          countryid:0,
          warehouseid: 0,
          yearid: 0,
          productid:0,
          satellite:"",
          july:"",
          august:"",
          september:"",
          october: "",
          november: "",
          december: "",
          january: "",
          february: "",
          march: "",
          april: "",
          may: "",
          june:"",
          comment:"",
          countryRegion: {
			countryid:0,
			countryname:"",
			regionid:0,
			region: {
				regionname: "",
				regionid:0
			}
		},
        warehouse: {
			warehouseid:0,
			warehousename:""
		},
		year: {
			yearid:0,
			fyname:"",
			isactive: true
		},
    product: {
			productid: 0,
			sapcode: "",
			productdescription: "",
			itemtype: {
				itemtypeid: 6,
				itemtypename: ""
			}},
    forecastshistory:[],
    historyid:0,
		forecastid_o:0,
		countryname_o: "",
		warehousename_o: "",
		fyname_o: "",
    regionname_o:"",
    productid_o:0,
    sapcode_o:0,
		productdescription_o: "",
		july_o: 0,
		august_o: 0,
		september_o: 0,
		october_o: 0,
		november_o: 0,
		december_o: 0,
		january_o: 0,
		february_o: 0,
		march_o: 0,
		april_o: 0,
		may_o: 0,
		june_o: 0,
    comment_o:"",
    modifiedat_o:"",
    kits:[],
    products:[],
    productLabels:[],
    productlabelname:"",
    

          CountryNameFilter:"",
          CountryNameOFilter:"",
          RegionNameFilter:"",
          RegionNameOFilter:"",
          WarehouseNameFilter:"",
          WarehouseNameOFilter:"",
          FiscalYearFilter:"",
          FiscalYearOFilter:"",
          ProductDescriptionFilter:"",
          ItemTypeFilter:"",
          ProductIdFilter:"",
          ProductIdOFilter:"",
          ProductDescriptionOFilter:"",
          ForecastIdFilter:"",
          ForecastIdOFilter:"",
          ForecastCommentFilter:"",
          ForecastCommentOFilter:"",
          CurrentYearFilter:"",
          forecastsWithoutFilter:[],
          forecastsHistoryWithoutFilter:[],
          regionNames: [],
          countryNames: [],
          fiscalYears: [], 
          productdescriptions: [],
          warehouseNames: [],
          loading: true,
          isEditClicked: false,
          fiscalYear:"",
          fiscalMonth:"",
          SapcodeDupNames:[],
          SapcodeDupDescriptionNames:[],
          SapcodeNames:[],
          SapcodeDescriptionNames:[],

          file: null,
          message: '',
          errors: []
          
      };

      this.handleFileChange = this.handleFileChange.bind(this);
      this.handleUpload = this.handleUpload.bind(this);
      this.downloadCSV = this.downloadCSV.bind(this);
      this.refreshList = this.refreshList.bind(this);
  }


  handleUpload = async () => {
    const { file } = this.state;
    if (!file) {
      alert('Please select a file to upload.');
      return;
    }
  
    const formData = new FormData();
    formData.append('file', file);
  
    try {
      const response = await axiosService.post('/forecastsupload/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      this.setState({ message: 'File uploaded successfully.', errors: [] });
      alert('File uploaded successfully.');
      window.location.reload();
  
    } catch (error) {
      let errorMessage = 'Upload failed';
      
      if (error.response?.data?.errors && error.response.data.errors.length > 0) {
        const errorList = error.response.data.errors.map(err => `${err.error}`).join('\n');
        errorMessage += `\n\nErrors:\n${errorList}`;
      } else if (error.message) {
        errorMessage = `Error: ${error.message}`;
      }
      
      this.setState({ message: errorMessage, errors: [] });
      alert(errorMessage);
      window.location.reload();
    }
  };
  


  handleFileChange = (event) => {
    this.setState({ file: event.target.files[0] });
  };

  downloadCSV() {
    const { forecasts } = this.state;
    const headers = [
      'sapcode',
      'satellite',
      'productdescription',
      'itemtype',
      'fiscalyear',
      'country',
      'warehouse',
      'comment',
      'july',
      'august',
      'september',
      'october',
      'november',
      'december',
      'january',
      'february',
      'march',
      'april',
      'may',
      'june'
    ];
  
    const escapeCSVField = (field) => {
      if (field == null) {
        return 'N/A';
      }
      if (typeof field === 'string') {
        return `"${field.replace(/"/g, '""')}"`; // Escape double quotes by doubling them
      }
      return field;
    };
  
    const rows = forecasts.map(dep => [
      escapeCSVField(dep.product?.sapcode),
      escapeCSVField(dep.satellite ?? dep.product?.satellite),
      escapeCSVField(dep.product?.productdescription),
      escapeCSVField(dep.product?.itemtype?.itemtypename),
      escapeCSVField(dep.year?.fyname),
      escapeCSVField(dep.countryRegion?.countryname),
      escapeCSVField(dep.warehouse?.warehousename),
      escapeCSVField(dep.comment),
      escapeCSVField(dep.july),
      escapeCSVField(dep.august),
      escapeCSVField(dep.september),
      escapeCSVField(dep.october),
      escapeCSVField(dep.november),
      escapeCSVField(dep.december),
      escapeCSVField(dep.january),
      escapeCSVField(dep.february),
      escapeCSVField(dep.march),
      escapeCSVField(dep.april),
      escapeCSVField(dep.may),
      escapeCSVField(dep.june)
    ]);
  
    let csvContent = '';
    csvContent += headers.join(';') + '\r\n';
    rows.forEach(rowArray => {
      const row = rowArray.join(';');
      csvContent += row + '\r\n';
    });
  
    const today = new Date();
    const formattedDate = today.toISOString().slice(0, 10); // Format today's date as YYYY-MM-DD
  
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], {
      type: 'text/csv;charset=utf-8'
  });
    saveAs(blob, `forecasts_${formattedDate}.csv`);
  }
  



  getCurrentFinancialYearAndMonth() {
    const today = new Date();
    let fiscalYear = "";
    let fiscalMonth = "";
  
    // Determine fiscal year
    if ((today.getMonth() + 1) <= 6) {
      fiscalYear = (today.getFullYear());
    } else {
      fiscalYear = today.getFullYear() + 1;
    }
  
    // Determine fiscal month
    fiscalMonth = (today.getMonth() + 1); // Adding 1 as months are 0-indexed
  
    return {
      fiscalYear: fiscalYear,
      fiscalMonth: fiscalMonth
    };
  }

 FilterFn(){
    var CountryNameFilter = this.state.CountryNameFilter;
    var RegionNameFilter = this.state.RegionNameFilter;
    var WarehouseNameFilter = this.state.WarehouseNameFilter;
    var FiscalYearFilter = this.state.FiscalYearFilter;
    var ProductDescriptionFilter = this.state.ProductDescriptionFilter;
    var ForecastIdFilter = this.state.ForecastIdFilter;
    var ForecastCommentFilter = this.state.ForecastCommentFilter;
    var ProductIdFilter = this.state.ProductIdFilter;
    var ItemTypeFilter = this.state.ItemTypeFilter;

    var filteredData=this.state.forecastsWithoutFilter.filter(
        function(el){
            return el.countryRegion?.countryname.toString().toLowerCase().includes(
                CountryNameFilter.toString().trim().toLowerCase()
            )&&  
                el.countryRegion?.region.regionname.toString().toLowerCase().includes(
                RegionNameFilter.toString().trim().toLowerCase()
            )&&  
                el.warehouse?.warehousename.toString().toLowerCase().includes(
                WarehouseNameFilter.toString().trim().toLowerCase()
            )&&  
                el.year?.fyname.toString().toLowerCase().includes(
                FiscalYearFilter.toString().trim().toLowerCase()
            )&&  
                el.product?.productdescription.toString().toLowerCase().includes(
                ProductDescriptionFilter.toString().trim().toLowerCase()
            )&&  
                el.forecastid.toString().toLowerCase().includes(
                ForecastIdFilter.toString().trim().toLowerCase()
            )&&  
            el.product?.sapcode.toString().toLowerCase().includes(
            ProductIdFilter.toString().trim().toLowerCase()
        )&&  
        el.product?.itemtype?.itemtypename.toString().toLowerCase().includes(
        ItemTypeFilter.toString().trim().toLowerCase()
    )&&  
    (el.comment || '').toString().toLowerCase().includes(
    ForecastCommentFilter.toString().trim().toLowerCase()
)
        }
    );

    this.setState({forecasts:filteredData});
}


FilterFnHistory(){

  var CountryNameOFilter = this.state.CountryNameOFilter;
  var RegionNameOFilter = this.state.RegionNameOFilter;
  var WarehouseNameOFilter = this.state.WarehouseNameOFilter;
  var FiscalYearOFilter = this.state.FiscalYearOFilter;
  var ProductDescriptionOFilter = this.state.ProductDescriptionOFilter;
  var ForecastIdOFilter = this.state.ForecastIdOFilter;
  var ForecastCommentOFilter = this.state.ForecastCommentOFilter;
  var ProductIdOFilter = this.state.ProductIdOFilter;

  var filteredDataHistory=this.state.forecastsHistoryWithoutFilter.filter(
    function(el){
        return el.countryname_o?.toString().toLowerCase().includes(
            CountryNameOFilter.toString().trim().toLowerCase()
        )&&  
            el.regionname_o?.toString().toLowerCase().includes(
            RegionNameOFilter.toString().trim().toLowerCase()
        )&&  
            el.warehousename_o?.toString().toLowerCase().includes(
            WarehouseNameOFilter.toString().trim().toLowerCase()
        )&&  
            el.fyname_o?.toString().toLowerCase().includes(
            FiscalYearOFilter.toString().trim().toLowerCase()
        )&&  
            el.productdescription_o?.toString().toLowerCase().includes(
            ProductDescriptionOFilter.toString().trim().toLowerCase()
        )&&  
            el.forecastid_o?.toString().toLowerCase().includes(
            ForecastIdOFilter.toString().trim().toLowerCase()
        )&&  
        el.sapcode_o.toString().toLowerCase().includes(
        ProductIdOFilter.toString().trim().toLowerCase()
    )&&  
    el.comment_o.toString().toLowerCase().includes(
    ForecastCommentOFilter.toString().trim().toLowerCase()
)
    }
);

  this.setState({forecastshistory:filteredDataHistory});

}

sortResult(prop,asc){
  var sortedData=this.state.forecastsWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({forecasts:sortedData});

}


sortResulHistory(prop,asc){

  var sortedDataHistory=this.state.forecastsHistoryWithoutFilter.sort(function(a,b){
    if(asc){
        return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
    }
    else{
        return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
    }
});

  this.setState({forecastshistory:sortedDataHistory});

}


changeCountryNameFilter = (e)=>{
  this.state.CountryNameFilter=e.target.value;
  this.FilterFn();
}

changeCountryNameOFilter = (e)=>{
  this.state.CountryNameOFilter=e.target.value;
  this.FilterFnHistory();
}

changeRegionNameFilter = (e)=>{
    this.state.RegionNameFilter=e.target.value;
    this.FilterFn();
  }

  changeRegionNameOFilter = (e)=>{
    this.state.RegionNameOFilter=e.target.value;
    this.FilterFnHistory();
  }

changeWarehouseNameFilter = (e)=>{
    this.state.WarehouseNameFilter=e.target.value;
    this.FilterFn();
  }

  changeWarehouseNameOFilter = (e)=>{
    this.state.WarehouseNameOFilter=e.target.value;
    this.FilterFnHistory();
  }


changeFiscalYearFilter = (e)=>{
    this.state.FiscalYearFilter=e.target.value;
    this.FilterFn();
  }

  changeFiscalYearOFilter = (e)=>{
    this.state.FiscalYearOFilter=e.target.value;
    this.FilterFnHistory();
  }


changeProductDescriptionFilter = (e)=>{
    this.state.ProductDescriptionFilter=e.target.value;
    this.FilterFn();
  }


  changeProductDescriptionOFilter = (e)=>{
    this.state.ProductDescriptionOFilter=e.target.value;
    this.FilterFnHistory();
  }

  changeItemTypeFilter = (e)=>{
    this.state.ItemTypeFilter=e.target.value;
    this.FilterFn();
  }

changeForecastIdFilter = (e)=>{
    this.state.ForecastIdFilter=e.target.value;
    this.FilterFn();
  }

  changeForecastIdOFilter = (e)=>{
    this.state.ForecastIdOFilter=e.target.value;
    this.FilterFnHistory();
  }

  changeProductIdFilter = (e)=>{
    this.state.ProductIdFilter=e.target.value;
    this.FilterFn();
  }

  changeProductIdOFilter = (e)=>{
    this.state.ProductIdOFilter=e.target.value;
    this.FilterFnHistory();
  }

  changeForecastCommentFilter = (e)=>{
    this.state.ForecastCommentFilter=e.target.value;
    this.FilterFn();
  }

  changeForecastCommentOFilter = (e)=>{
    this.state.ForecastCommentOFilter=e.target.value;
    this.FilterFnHistory();
  }


refreshList = () => {
    const params = {};
    const sat = getSatelliteApiParam(this.context?.satellite);
    if (sat) params.satellite = sat;
    axiosService.get('/forecasts/', { params })
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({ forecasts: data, forecastsWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };

  refreshListForecastsHistory = () => {
    axiosService.get('/forecastshistoryv2/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({ forecastshistory: data, forecastsHistoryWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };

fetchRegionNames() {
  axiosService.get('/regionnames/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const regionNames = data.map(item => item.regionname);
      this.setState({ regionNames: regionNames });
    })
    .catch(error => {
      console.error("Error fetching region names:", error);
    });
}


fetchCountryNames() {
  axiosService.get('/countries/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const countryNames = filteredData.map(item => item.countryname);
      this.setState({ countryNames: countryNames });
    })
    .catch(error => {
      console.error("Error fetching country names:", error);
    });
}

fetchFiscalYears() {
    axiosService.get('/years/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const fiscalYears = filteredData.map(item => item.fyname);
        this.setState({ fiscalYears: fiscalYears });
      })
      .catch(error => {
        console.error("Error fetching fiscal years:", error);
      });
  }

  fetchProductDescriptions() {
    axiosService.get('/defaultproducts/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const productdescriptions = filteredData.map(item => item.productdescription);
        this.setState({ productdescriptions: productdescriptions });
      })
      .catch(error => {
        console.error("Error fetching products :", error);
      });
  }

  fetchWarehouseNames() {
    axiosService.get('/warehouses/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const warehouseNames = filteredData.map(item => item.warehousename);
        this.setState({ warehouseNames: warehouseNames });
      })
      .catch(error => {
        console.error("Error fetching warehouse names:", error);
      });
  }

handleInput = (event) => {
    const inputValue = event.target.value;
    const regex = /^\d*$/;
    if (!regex.test(inputValue)) {
      event.target.value = inputValue.replace(/[^0-9]/g, '');
    }
  };

  fetchProducts() {
    axiosService.get('/defaultproductscreate/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        // Filter the data where purchasetypeid is equal to 1
        const filteredData = data.filter((item) => item.productlabelid === 1 && item.isactive === true);
  
        // Extract unique warehouseid values from the filtered data
        const products = filteredData.map((item) => item.productdescription);
  
        this.setState({ products: products });
      })
      .catch((error) => {
        console.error('Error fetching Products data:', error);
      });
  }

  fetchKits() {
    axiosService.get('/defaultproductscreate/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        // Filter the data where purchasetypeid is equal to 1
        const filteredData = data.filter((item) => item.productlabelid === 2 &&  item.isactive === true);
  
        // Extract unique warehouseid values from the filtered data
        const kits = filteredData.map((item) => item.productdescription);
  
        this.setState({ kits: kits });
      })
      .catch((error) => {
        console.error('Error fetching Products data:', error);
      });
  }

  fetchProductLables() {
    axiosService.get('/productlabels/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
       
        const productLabels = data.map((item) => item.productlabelname);
  
        this.setState({ productLabels: productLabels });
      })
      .catch((error) => {
        console.error('Error fetching ProductLabels data:', error);
      });
  }

  formatUpdateDate(update_y) {
    if (!update_y) {
      return 'N/A'; // Handle the case where update_y is not available
    }

    const parsedDate = new Date(update_y);
    const formattedDate = parsedDate.toLocaleDateString(); // Adjust the format as needed

    return formattedDate;
  }



  
fetchSapcodeDupNames() {
  axiosService.get('/defaultkits/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const SapcodeDupNames = filteredData.map(item => item.sapcodedup);

      const sapcodeToProductDescriptionMap = {};
      const sapcodeToSatelliteMap = {};
      filteredData.forEach(item => {
        sapcodeToProductDescriptionMap[item.sapcodedup] = item.productdescription;
        sapcodeToSatelliteMap[item.sapcodedup] = item.satellite ?? '';
      });

      this.setState({ SapcodeDupNames: SapcodeDupNames, SapcodeDupDescriptionNames: sapcodeToProductDescriptionMap, SapcodeDupSatelliteNames: sapcodeToSatelliteMap });
    })
    .catch(error => {
      console.error("Error fetching product sapcode:", error);
    });
}

findProductDescriptionForSapcodeDup(sapcodedup) {
  const productDescriptionMap = this.state.SapcodeDupDescriptionNames;
  return productDescriptionMap[sapcodedup] || "Kit not found";
}


fetchProductNames() {
  axiosService.get('/defaultitems/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const productNames = filteredData.map(item => item.productdescription);
      this.setState({ productNames: productNames });
    })
    .catch(error => {
      console.error("Error fetching product names:", error);
    });
}

fetchSapcodeNames() {
  axiosService.get('/defaultitems/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const SapcodeNames = filteredData.map(item => item.sapcode);

      const sapcodeToProductDescriptionMap = {};
      const sapcodeToSatelliteMap = {};
      filteredData.forEach(item => {
        sapcodeToProductDescriptionMap[item.sapcode] = item.productdescription;
        sapcodeToSatelliteMap[item.sapcode] = item.satellite ?? '';
      });

      this.setState({ SapcodeNames: SapcodeNames, SapcodeDescriptionNames: sapcodeToProductDescriptionMap, SapcodeSatelliteNames: sapcodeToSatelliteMap });
    })
    .catch(error => {
      console.error("Error fetching product sapcode:", error);
    });
}

findProductDescriptionForSapcode(sapcode) {
  const productDescriptionMap = this.state.SapcodeDescriptionNames;
  return productDescriptionMap[sapcode] || "Product not found";
}

findSatelliteForSapcodeDup(sapcodedup) {
  return this.state.SapcodeDupSatelliteNames?.[sapcodedup] ?? '';
}

findSatelliteForSapcode(sapcode) {
  return this.state.SapcodeSatelliteNames?.[sapcode] ?? '';
}

componentDidUpdate(_prevProps, _prevState) {
  const sat = this.context?.satellite;
  if (this._lastForecastsSatellite !== sat) {
    this._lastForecastsSatellite = sat;
    this.setState({ loading: true });
    this.refreshList();
  }
}

componentDidMount(){
  this._lastForecastsSatellite = this.context?.satellite;
  this.refreshList();
  this.refreshListForecastsHistory();
  this.fetchRegionNames();
  this.fetchCountryNames();
  this.fetchFiscalYears();
  this.fetchProductDescriptions();
  this.fetchWarehouseNames();
  this.fetchProducts();
  this.fetchKits();
  this.fetchProductLables();
  this.fetchSapcodeDupNames();
  this.fetchSapcodeNames();
}

changeCountryName =(e)=>{
  this.setState({countryname:e.target.value});
}


changeRegionName =(e)=>{
  this.setState({regionname:e.target.value});
}

changeFiscalYear =(e)=>{
    this.setState({fyname:e.target.value});
  }

changeProductDescription =(e)=>{
    this.setState({productdescription:e.target.value});
  }


  changeComment =(e)=>{
    this.setState({comment:e.target.value});
  }

changeJuly =(e)=>{
    this.setState({july:e.target.value});
  }

changeAugust =(e)=>{
    this.setState({august:e.target.value});
  }

changeSeptember =(e)=>{
    this.setState({september:e.target.value});
  }

changeOctober =(e)=>{
    this.setState({october:e.target.value});
  }
changeNovember =(e)=>{
    this.setState({november:e.target.value});
  }

changeDecember =(e)=>{
    this.setState({december:e.target.value});
  }

changeJanuary=(e)=>{
    this.setState({january:e.target.value});
  }

changeFebruary =(e)=>{
    this.setState({february:e.target.value});
  }

changeMarch =(e)=>{
    this.setState({march:e.target.value});
  }

changeApril =(e)=>{
    this.setState({april:e.target.value});
  }

changeMay =(e)=>{
    this.setState({may:e.target.value});
  }

changeJune =(e)=>{
    this.setState({june:e.target.value});
  }

addClick(){
  this.setState({
      modalTitle:"Add Forecast",
      forecastid:0,
      countryid:0,
      countryname:"",
      warehousename:"",
      fyname:"",
      productdescription:"",
      satellite:"",
      july:"",
      august:"",
      september:"",
      october:"",
      november:"",
      december:"",
      january:"",
      february:"",
      march:"",
      april:"",
      may:"",
      june:"",
      comment:"",
      isEditClicked: false,
  });
}


editClick(dep) {
  this.setState({
    modalTitle: "Edit Forecast",
    forecastid: dep.forecastid,
    countryid: dep.countryid,
    countryname: dep.countryRegion.countryname,
    warehousename:dep.warehouse.warehousename,
    fyname:dep.year.fyname,
    sapcode:dep.product.sapcode,
    productdescription:dep.product.productdescription,
    satellite: dep.satellite ?? dep.product?.satellite ?? '',
    july:dep.july,
    august:dep.august,
    september:dep.september,
    october:dep.october,
    november:dep.november,
    december:dep.december,
    january:dep.january,
    february:dep.february,
    march:dep.march,
    april:dep.april,
    may:dep.may,
    june:dep.june,
    comment:dep.comment,
    initialCountryname: dep.countryRegion.countryname,
    initialWarehousename:dep.warehouse.warehousename,
    initialFyname:dep.year.fyname,
    initialProductdescription:dep.product.productdescription,
    initialSatellite: dep.satellite ?? dep.product?.satellite ?? '',
    initialJuly:dep.july,
    initialAugust:dep.august,
    initialSeptember:dep.september,
    initialOctober:dep.october,
    initialNovember:dep.november,
    initialDecember:dep.december,
    initialJanuary:dep.january,
    initialFebruary:dep.february,
    initialMarch:dep.march,
    initialApril:dep.april,
    initialMay:dep.may,
    initialJune:dep.june,
    initialComment:dep.comment,
    isEditClicked: true,
  });
}

createClick() {
  const { countryname, warehousename, fyname, productdescription, satellite, july, august, september, october,
  november, december, january, february, march, april, may, june, comment } = this.state;

  if (!countryname) {
    alert('Country is required');
    return;
  }


  if (!fyname) {
    alert('Year is required');
    return;
  }

  if (!productdescription) {
    alert('Product is required');
    return;
  }

  axiosService.post('/forecastscreate/', {
      countryname: countryname,
      warehousename: warehousename,
      fyname: fyname,
      productdescription:productdescription,
      satellite: satellitePayloadValue(satellite),
      july:july,
      august:august,
      september:september,
      october:october,
      november:november,
      december:december,
      january:january,
      february:february,
      march:march,
      april:april,
      may:may,
      june:june,
      comment:comment
    })
    .then(result => {
      alert('Forecast created');
      this.refreshList();
      //window.location.reload();
    })
    .catch(error => {
      alert('Failed');
    });
}

updateClick(id) {
  const { countryname, warehousename, fyname, productdescription, satellite, july, august, september, october,
    november, december, january, february, march, april, may, june,comment, initialCountryname,
    initialWarehousename, initialFyname, initialProductdescription, initialSatellite, initialJuly, initialAugust,
    initialSeptember, initialOctober, initialNovember, initialDecember, initialJanuary,
    initialFebruary, initialMarch, initialApril, initialMay, initialJune,initialComment  } = this.state;

  if (
    countryname === initialCountryname &&
    warehousename === initialWarehousename&&
    fyname === initialFyname &&
    productdescription === initialProductdescription &&
    satellite === initialSatellite &&
    july === initialJuly &&
    august === initialAugust &&
    september === initialSeptember &&
    october === initialOctober &&
    november === initialNovember &&
    december === initialDecember &&
    january === initialJanuary &&
    february === initialFebruary &&
    march === initialMarch &&
    april === initialApril &&
    may === initialMay &&
    june === initialJune &&
    comment === initialComment
  ) {
    alert('No changes detected');
    return;
  }


  if (!countryname) {
    alert('Country is required');
    return;
  }


  if (!fyname) {
    alert('Year is required');
    return;
  }

  if (!productdescription) {
    alert('Product is required');
    return;
  }

  
  axiosService.patch('/forecasts/' + id + '/', {
      countryid: this.state.countryid,
      countryname: this.state.countryname,
      warehousename: this.state.warehousename,
      fyname: this.state.fyname,
      productdescription : this.state.productdescription,
      satellite: satellitePayloadValue(this.state.satellite),
      july : this.state.july,
      august : this.state.august,
      september : this.state.september,
      october : this.state.october,
      november : this.state.november,
      december : this.state.december,
      january : this.state.january,
      february : this.state.february,
      march : this.state.march,
      april : this.state.april,
      may : this.state.may,
      june : this.state.june,
      comment : this.state.comment
    })
    .then(result => {
      alert('Update successful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}



copyClick() {
  const { countryname, warehousename, fyname, productdescription, satellite, july, august, september, october,
    november, december, january, february, march, april, may, june,comment, initialCountryname,
    initialWarehousename, initialFyname, initialProductdescription, initialSatellite, initialJuly, initialAugust,
    initialSeptember, initialOctober, initialNovember, initialDecember, initialJanuary,
    initialFebruary, initialMarch, initialApril, initialMay, initialJune,initialComment  } = this.state;

  if (
    countryname === initialCountryname &&
    warehousename === initialWarehousename&&
    fyname === initialFyname &&
    productdescription === initialProductdescription &&
    satellite === initialSatellite &&
    july === initialJuly &&
    august === initialAugust &&
    september === initialSeptember &&
    october === initialOctober &&
    november === initialNovember &&
    december === initialDecember &&
    january === initialJanuary &&
    february === initialFebruary &&
    march === initialMarch &&
    april === initialApril &&
    may === initialMay &&
    june === initialJune &&
    comment === initialComment
  ) {
    alert('No changes detected');
    return;
  }


  if (!countryname) {
    alert('Country is required');
    return;
  }


  if (!fyname) {
    alert('Year is required');
    return;
  }

  if (!productdescription) {
    alert('Product is required');
    return;
  }

  
  axiosService.post('/forecastscreate/', {
      countryid: this.state.countryid,
      countryname: this.state.countryname,
      warehousename: this.state.warehousename,
      fyname: this.state.fyname,
      productdescription : this.state.productdescription,
      satellite: satellitePayloadValue(satellite),
      july : this.state.july,
      august : this.state.august,
      september : this.state.september,
      october : this.state.october,
      november : this.state.november,
      december : this.state.december,
      january : this.state.january,
      february : this.state.february,
      march : this.state.march,
      april : this.state.april,
      may : this.state.may,
      june : this.state.june,
      comment : this.state.comment
    })
    .then(result => {
      alert('Forecast created');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}

deleteClick(id) {
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/forecasts/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        window.location.reload();
      })
      .catch(error => {
        alert('Delete failed');
      });
  }
}


render(){
  const {
      forecasts,
      modalTitle,
      forecastid,
      countryid,
      countryname,
      warehousename,
      regionname,
      fyname,
      productdescription,
      july,
      august,
      september,
      october,
      november,
      december,
      january,
      february,
      march,
      april,
      may,
      june,
      comment,
      products,
      kits,
      productlabelname,
      forecastshistory,
      forecastid_o,
      countryname_o,
      warehousename_o,
      regionname_o,
      fyname_o,
      productdescription_o,
      july_o,
      august_o,
      september_o,
      november_o,
      december_o,
      january_o,
      february_o,
      march_o,
      april_o,
      may_o,
      june_o,
      comment_o,
      modifiedat_o,
      loading,
      fiscalYears,

      message,
      errors
  

  }=this.state;

  const { fiscalYear, fiscalMonth } = this.getCurrentFinancialYearAndMonth();
  const selectedFiscalYear = parseInt(this.state.fyname, 10);
  const selectedMonthIsJuly = parseInt(7, 10);
  const selectedMonthIsAugust = parseInt(8, 10);
  const selectedMonthIsSeptember = parseInt(9, 10);
  const selectedMonthIsOctober = parseInt(10, 10);
  const selectedMonthIsNovember = parseInt(11, 10);
  const selectedMonthIsDecember = parseInt(12, 10);

  const selectedMonthIsJanuary = parseInt(1, 10);
  const selectedMonthIsFebruary = parseInt(2, 10);
  const selectedMonthIsMarch = parseInt(3, 10);
  const selectedMonthIsApril = parseInt(4, 10);
  const selectedMonthIsMay = parseInt(5, 10);
  const selectedMonthIsJune = parseInt(6, 10);

  const isDisabledYear = fiscalYear > selectedFiscalYear;
  const isBetweenJulyAndDecember =
  fiscalMonth >= 7 && fiscalMonth <= 12; // Check if fiscal month is between July (6) and November (11) inclusive
  const isBetweenJanuaryAndJune =
  fiscalMonth >= 1 && fiscalMonth <= 6;

  const isYearCanBeDisable = selectedFiscalYear <= fiscalYear ; // Check if it's the selected fiscal year
  const isPassedMonthJuly = fiscalMonth > selectedMonthIsJuly;
  const isDisabledMonthJuly = (isYearCanBeDisable && isBetweenJulyAndDecember && isPassedMonthJuly) || isDisabledYear;
  const isPassedMonthAugust = fiscalMonth > selectedMonthIsAugust;
  const isDisabledMonthAugust = (isYearCanBeDisable && isBetweenJulyAndDecember && isPassedMonthAugust) || isDisabledYear;
  const isPassedMonthSeptember = fiscalMonth > selectedMonthIsSeptember;
  const isDisabledMonthSeptember = (isYearCanBeDisable && isBetweenJulyAndDecember && isPassedMonthSeptember) || isDisabledYear;
  const isPassedMonthOctober = fiscalMonth > selectedMonthIsOctober;
  const isDisabledMonthOctober = (isYearCanBeDisable && isBetweenJulyAndDecember && isPassedMonthOctober) || isDisabledYear;
  const isPassedMonthNovember = fiscalMonth > selectedMonthIsNovember;
  const isDisabledMonthNovember = (isYearCanBeDisable && isBetweenJulyAndDecember && isPassedMonthNovember) || isDisabledYear;
  const isPassedMonthDecember =  selectedMonthIsDecember && isBetweenJanuaryAndJune ;
  const isDisabledMonthDecember = (isYearCanBeDisable && isBetweenJulyAndDecember && isPassedMonthDecember) || isDisabledYear;

  const isPassedMonthJanuary = fiscalMonth > selectedMonthIsJanuary;
  const isDisabledMonthJanuary = (isYearCanBeDisable && isBetweenJanuaryAndJune && isPassedMonthJanuary) || isDisabledYear;
  const isPassedMonthFebruary = fiscalMonth > selectedMonthIsFebruary;
  const isDisabledMonthFebruary= (isYearCanBeDisable && isBetweenJanuaryAndJune && isPassedMonthFebruary) || isDisabledYear;
  const isPassedMonthMarch = fiscalMonth > selectedMonthIsMarch;
  const isDisabledMonthMarch = (isYearCanBeDisable && isBetweenJanuaryAndJune && isPassedMonthMarch) || isDisabledYear;
  const isPassedMonthApril = fiscalMonth > selectedMonthIsApril;
  const isDisabledMonthApril = (isYearCanBeDisable && isBetweenJanuaryAndJune && isPassedMonthApril) || isDisabledYear;
  const isPassedMonthMay = fiscalMonth > selectedMonthIsMay;
  const isDisabledMonthMay = (isYearCanBeDisable && isBetweenJulyAndDecember && isPassedMonthMay) || isDisabledYear;
  const isPassedMonthJune =  selectedMonthIsJune && isBetweenJulyAndDecember ;
  const isDisabledMonthJune = (isYearCanBeDisable && isBetweenJanuaryAndJune && isPassedMonthJune) || isDisabledYear;

  return(
    
<div className="scrollable-container" >
<MyPage />
<SubTabsInputs />
<button  type="button"
className="btn btn-primary m-2 float-end"
onClick={this.downloadCSV}
style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
>
  Download

</button>

<div style={{ textAlign: 'left', fontWeight: 'bold',padding:"10px", fontSize: "14px" }}>
      Forecasts
    </div>


<div className="d-flex flex-row align-items-center">
    <input 
    disabled={!isSuperAdmin()}
    className="form-control m-2" 
    type="file" 
    style={{ width: "200px", height:"30px", fontSize: "12px" }}
    onChange={this.handleFileChange} />
    <button 
    disabled={!isSuperAdmin()}
    type="button"
    className="btn btn-primary m-2 float-end"
    style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
    onClick={this.handleUpload}>Upload File</button>
     
</div>

<div className="table-container">
<table className="table table-striped" >
<thead>
<tr  className="header-row-fixed">

  <th  style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center"
      
      >
      <input className="form-control m-2"
      style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeForecastIdFilter}
      placeholder="Filter"/>

      </div>
      ForecastId
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "150px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductIdFilter}
      placeholder="Filter"/>
      </div>
      Product SAP Code / SKU
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Satellite
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "100px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductDescriptionFilter}
      placeholder="Filter"/>

      </div>
      Product
  </th>


  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "100px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeItemTypeFilter}
      placeholder="Filter"/>
      </div>
      ItemType
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFiscalYearFilter}
      placeholder="Filter"/>
      </div>
      Fiscal Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeRegionNameFilter}
      placeholder="Filter"/>

      </div>
      Region
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeCountryNameFilter}
      placeholder="Filter"/>
      </div>
      Country
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeWarehouseNameFilter}
      placeholder="Filter"/>
      </div>
      Warehouse
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeForecastCommentFilter}
      placeholder="Filter"/>
      </div>
      Comments
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jul
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Aug
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Sep
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Oct
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Nov
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Dec
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jan
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Feb
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Mar
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Apr
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      May
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jun
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {forecasts.map(dep=>
      <tr key={dep.forecastid} className="row-hover">
          <td className="table-text">{dep.forecastid}</td>
          <td className="table-text">{dep.product?.sapcode ?? 'N/A'}</td>
          <td className="table-text">{displaySatellite(dep.satellite ?? dep.product?.satellite, { csv: true })}</td>
          <td className="table-text">{dep.product?.productdescription ?? 'N/A'}</td>
          <td className="table-text">{dep.product?.itemtype?.itemtypename ?? 'N/A'}</td>
          <td className="table-text">{dep.year?.fyname ?? 'N/A'}</td>
          <td className="table-text">{dep.countryRegion?.region?.regionname ?? 'N/A'}</td>
          <td className="table-text">{dep.countryRegion?.countryname ?? 'N/A'}</td>
          <td className="table-text">{dep.warehouse?.warehousename ?? 'N/A'}</td>
          <td className="table-text">{dep.comment ?? 'N/A'}</td>
          <td className="table-text">{dep.july ?? 'N/A'}</td>
          <td className="table-text">{dep.august ?? 'N/A'}</td>
          <td className="table-text">{dep.september ?? 'N/A'}</td>
          <td className="table-text">{dep.october ?? 'N/A'}</td>
          <td className="table-text">{dep.november ?? 'N/A'}</td>
          <td className="table-text">{dep.december ?? 'N/A'}</td>
          <td className="table-text">{dep.january ?? 'N/A'}</td>
          <td className="table-text">{dep.february ?? 'N/A'}</td>
          <td className="table-text">{dep.march ?? 'N/A'}</td>
          <td className="table-text">{dep.april ?? 'N/A'}</td>
          <td className="table-text">{dep.may ?? 'N/A'}</td>
          <td className="table-text">{dep.june ?? 'N/A'}</td>
          <td className="table-text">

          <div style={{ display: "flex", justifyContent: "center" }}>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal2"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          onClick={()=>this.deleteClick(dep.forecastid)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
              </svg>
          </button>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-primary m-2"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal1"
          onClick={()=>this.editClick(dep)}
          style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
            >
             Copy
          </button>
          </div>
          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>


<div style={{ textAlign: 'left', fontWeight: 'bold', padding:"10px" , fontSize: "14px"}}>
      History
    </div>
<div className="table-container">
<table className="table table-striped">
<thead>
<tr>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
      style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeForecastIdOFilter}
      placeholder="Filter"/>

      </div>
      ForecastId
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "150px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductIdOFilter}
      placeholder="Filter"/>
      </div>
      Product SAP Code / SKU
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Satellite
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "100px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductDescriptionOFilter}
      placeholder="Filter"/>

      </div>
      Product
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFiscalYearOFilter}
      placeholder="Filter"/>

      </div>
      Fiscal Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Saved Date
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeRegionNameOFilter}
      placeholder="Filter"/>
      </div>
      Region
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeCountryNameOFilter}
      placeholder="Filter"/>
      </div>
      Country
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeWarehouseNameOFilter}
      placeholder="Filter"/>
      </div>
      Warehouse
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeForecastCommentOFilter}
      placeholder="Filter"/>
      </div>
      Comments
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jul
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Aug
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Sep
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Oct
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Nov
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Dec
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jan
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Feb
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Mar
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Apr
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      May
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jun
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {forecastshistory.map(dep=>
      <tr key={dep.historyid} className="row-hover">
      <td className="table-text">{dep.forecastid_o ?? 'N/A'}</td>
      <td className="table-text">{dep.sapcode_o ?? 'N/A'}</td>
      <td className="table-text">{dep.satellite_o ?? 'N/A'}</td>
      <td className="table-text">{dep.productdescription_o ?? 'N/A'}</td>
      <td className="table-text">{dep.fyname_o ?? 'N/A'}</td>
      <td className="table-text">{this.formatUpdateDate(dep.modifiedat_o) ?? 'N/A'}</td>
      <td className="table-text">{dep.regionname_o ?? 'N/A'}</td>
      <td className="table-text">{dep.countryname_o ?? 'N/A'}</td>
      <td className="table-text">{dep.warehousename_o ?? 'N/A'}</td>
      <td className="table-text">{dep.comment_o ?? 'N/A'}</td>
      <td className="table-text">{dep.july_o ?? 'N/A'}</td>
      <td className="table-text">{dep.august_o ?? 'N/A'}</td>
      <td className="table-text">{dep.september_o ?? 'N/A'}</td>
      <td className="table-text">{dep.october_o ?? 'N/A'}</td>
      <td className="table-text">{dep.november_o ?? 'N/A'}</td>
      <td className="table-text">{dep.december_o ?? 'N/A'}</td>
      <td className="table-text">{dep.january_o ?? 'N/A'}</td>
      <td className="table-text">{dep.february_o ?? 'N/A'}</td>
      <td className="table-text">{dep.march_o ?? 'N/A'}</td>
      <td className="table-text">{dep.april_o ?? 'N/A'}</td>
      <td className="table-text">{dep.may_o ?? 'N/A'}</td>
      <td className="table-text">{dep.june_o ?? 'N/A'}</td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Fiscal Year</span>
          <select
            className="form-select"
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Country</span>
          <select
            className="form-select"
            value={this.state.countryname}
            onChange={(event) => this.setState({ countryname: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select a country</option>
            {this.state.countryNames.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Warehouse</span>
          <select
            className="form-select"
            value={this.state.warehousename}
            onChange={(event) => this.setState({ warehousename: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select a warehouse</option>
            {this.state.warehouseNames.map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >ProductType</span>
          <select
            className="form-select"
            value={this.state.productlabelname}
            onChange={(event) => this.setState({ productlabelname: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select productType</option>
            {this.state.productLabels.map((productlabel) => (
              <option key={productlabel} value={productlabel}>
                {productlabel}
              </option>
            ))}
          </select>
        </div>

{this.state.productlabelname === "FULL" && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Kit</span>
  <select
    className="form-select"
    value={this.state.sapcode}
    onChange={(event) => {
      const selectedSapcode= event.target.value;
      this.setState({ sapcode: selectedSapcode });
      // Automatically find and set the corresponding productdescription
      const productdescription = this.findProductDescriptionForSapcodeDup(selectedSapcode);
      const satellite = this.findSatelliteForSapcodeDup(selectedSapcode);
      this.setState({ productdescription, satellite });
    }}
    disabled={this.state.isEditClicked}
    style={{ fontSize: "12px" }}
  >
    <option value="">Select kit SAPCODE</option>
    {this.state.SapcodeDupNames.map((sapcode) => (
      <option key={sapcode} value={sapcode}>
        {sapcode}
      </option>
    ))}
  </select>
</div>

)}

{this.state.productlabelname === "FULL" && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Kit Name</span>
  <input
    type="text"
    className="form-control"
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>

)}

{this.state.productlabelname === "UNIT" && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Item SAP Code / SKU</span>
  <select
    className="form-select"
    value={this.state.sapcode}
    onChange={(event) => {
      const selectedSapcode = event.target.value;
      this.setState({ sapcode: selectedSapcode });
      // Automatically find and set the corresponding productdescription
      const productdescription = this.findProductDescriptionForSapcode(selectedSapcode);
      const satellite = this.findSatelliteForSapcode(selectedSapcode);
      this.setState({ productdescription, satellite });
    }}
    disabled={this.state.isEditClicked}
    style={{ fontSize: "12px" }}
  >
    <option value="">Select item SAPCODE</option>
    {this.state.SapcodeNames.map((sapcode) => (
      <option key={sapcode} value={sapcode}>
        {sapcode}
      </option>
    ))}
  </select>
</div>
)}


{this.state.productlabelname === "UNIT" && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Item Name</span>
  <input
    type="text"
    className="form-control"
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>

)}

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Satellite</span>
          <input
            type="text"
            className="form-control"
            value={this.state.satellite}
            onChange={(e) => this.setState({ satellite: e.target.value })}
            placeholder="e.g. GEO, LEO"
            style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Comments</span>
          <input type="text" className="form-control" value={comment} onChange={this.changeComment} 
          style={{ fontSize: "12px" }} 
          />
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Jul</span>
          <input type="number" className="form-control" value={july} onChange={this.changeJuly} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Aug</span>
          <input type="text" className="form-control" value={august} onChange={this.changeAugust}
          onInput={this.handleInput}
          style={{ fontSize: "12px" }} 
           />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Sep</span>
          <input type="text" className="form-control" value={september} onChange={this.changeSeptember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Oct</span>
          <input type="text" className="form-control" value={october} onChange={this.changeOctober} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Nov</span>
          <input type="text" className="form-control" value={november} onChange={this.changeNovember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Dec</span>
          <input type="text" className="form-control" value={december} onChange={this.changeDecember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jan</span>
          <input type="text" className="form-control" value={january} onChange={this.changeJanuary} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Feb</span>
          <input type="text" className="form-control" value={february} onChange={this.changeFebruary} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Mar</span>
          <input type="text" className="form-control" value={march} onChange={this.changeMarch} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Apr</span>
          <input type="text" className="form-control" value={april} onChange={this.changeApril} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>May</span>
          <input type="text" className="form-control" value={may} onChange={this.changeMay} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jun</span>
          <input type="text" className="form-control" value={june} onChange={this.changeJune} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        {forecastid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {forecastid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.updateClick(forecastid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>

<div className="modal fade" id="exampleModal1" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Fiscal Year</span>
          <select
            className="form-select"
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
           
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Country</span>
          <select
            className="form-select"
            value={this.state.countryname}
            onChange={(event) => this.setState({ countryname: event.target.value })}
           
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select a country</option>
            {this.state.countryNames.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Warehouse</span>
          <select
            className="form-select"
            value={this.state.warehousename}
            onChange={(event) => this.setState({ warehousename: event.target.value })}
            
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select a warehouse</option>
            {this.state.warehouseNames.map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >ProductType</span>
          <select
            className="form-select"
            value={this.state.productlabelname}
            onChange={(event) => this.setState({ productlabelname: event.target.value })}
           
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select productType</option>
            {this.state.productLabels.map((productlabel) => (
              <option key={productlabel} value={productlabel}>
                {productlabel}
              </option>
            ))}
          </select>
        </div>

{this.state.productlabelname === "FULL" && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Kit</span>
  <select
    className="form-select"
    value={this.state.sapcode}
    onChange={(event) => {
      const selectedSapcode= event.target.value;
      this.setState({ sapcode: selectedSapcode });
      // Automatically find and set the corresponding productdescription
      const productdescription = this.findProductDescriptionForSapcodeDup(selectedSapcode);
      const satellite = this.findSatelliteForSapcodeDup(selectedSapcode);
      this.setState({ productdescription, satellite });
    }}
    
    style={{ fontSize: "12px" }}
  >
    <option value="">Select kit SAPCODE</option>
    {this.state.SapcodeDupNames.map((sapcode) => (
      <option key={sapcode} value={sapcode}>
        {sapcode}
      </option>
    ))}
  </select>
</div>

)}

{this.state.productlabelname === "FULL" && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Kit Name</span>
  <input
    type="text"
    className="form-control"
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>

)}

{this.state.productlabelname === "UNIT" && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Item SAP Code / SKU</span>
  <select
    className="form-select"
    value={this.state.sapcode}
    onChange={(event) => {
      const selectedSapcode = event.target.value;
      this.setState({ sapcode: selectedSapcode });
      // Automatically find and set the corresponding productdescription
      const productdescription = this.findProductDescriptionForSapcode(selectedSapcode);
      const satellite = this.findSatelliteForSapcode(selectedSapcode);
      this.setState({ productdescription, satellite });
    }}
   
    style={{ fontSize: "12px" }}
  >
    <option value="">Select item SAPCODE</option>
    {this.state.SapcodeNames.map((sapcode) => (
      <option key={sapcode} value={sapcode}>
        {sapcode}
      </option>
    ))}
  </select>
</div>
)}


{this.state.productlabelname === "UNIT" && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Item Name</span>
  <input
    type="text"
    className="form-control"
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>

)}

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Satellite</span>
          <input
            type="text"
            className="form-control"
            value={this.state.satellite}
            onChange={(e) => this.setState({ satellite: e.target.value })}
            placeholder="e.g. GEO, LEO"
            style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Comments</span>
          <input type="text" className="form-control" value={comment} onChange={this.changeComment} 
          style={{ fontSize: "12px" }} 
          />
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Jul</span>
          <input type="number" className="form-control" value={july} onChange={this.changeJuly} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Aug</span>
          <input type="text" className="form-control" value={august} onChange={this.changeAugust}
          onInput={this.handleInput}
          style={{ fontSize: "12px" }} 
           />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Sep</span>
          <input type="text" className="form-control" value={september} onChange={this.changeSeptember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Oct</span>
          <input type="text" className="form-control" value={october} onChange={this.changeOctober} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Nov</span>
          <input type="text" className="form-control" value={november} onChange={this.changeNovember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Dec</span>
          <input type="text" className="form-control" value={december} onChange={this.changeDecember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jan</span>
          <input type="text" className="form-control" value={january} onChange={this.changeJanuary} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Feb</span>
          <input type="text" className="form-control" value={february} onChange={this.changeFebruary} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Mar</span>
          <input type="text" className="form-control" value={march} onChange={this.changeMarch} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Apr</span>
          <input type="text" className="form-control" value={april} onChange={this.changeApril} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>May</span>
          <input type="text" className="form-control" value={may} onChange={this.changeMay} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jun</span>
          <input type="text" className="form-control" value={june} onChange={this.changeJune} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        {forecastid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.copyClick()}>
            Create
          </button>
        ) : null}

        {forecastid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>

<div className="modal fade" id="exampleModal2" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Fiscal Year</span>
          <select
            className="form-select"
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Country</span>
          <select
            className="form-select"
            value={this.state.countryname}
            onChange={(event) => this.setState({ countryname: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select a country</option>
            {this.state.countryNames.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Warehouse</span>
          <select
            className="form-select"
            value={this.state.warehousename}
            onChange={(event) => this.setState({ warehousename: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select a warehouse</option>
            {this.state.warehouseNames.map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>




        <div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>SAP Code / SKU</span>
  <input
    type="text"
    className="form-control"
    value={this.state.sapcode} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ sapcode: event.target.value })} // Update productdescription state
    disabled={this.state.isEditClicked}
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>


<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Product Name</span>
  <input
    type="text"
    className="form-control"
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    disabled={this.state.isEditClicked}
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>




        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Satellite</span>
          <input
            type="text"
            className="form-control"
            value={this.state.satellite}
            onChange={(e) => this.setState({ satellite: e.target.value })}
            placeholder="e.g. GEO, LEO"
            style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Comments</span>
          <input type="text" className="form-control" value={comment} onChange={this.changeComment} 
          style={{ fontSize: "12px" }} 
          />
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Jul</span>
          <input type="number" className="form-control" value={july} onChange={this.changeJuly} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Aug</span>
          <input type="text" className="form-control" value={august} onChange={this.changeAugust}
          onInput={this.handleInput}
          style={{ fontSize: "12px" }} 
           />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Sep</span>
          <input type="text" className="form-control" value={september} onChange={this.changeSeptember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Oct</span>
          <input type="text" className="form-control" value={october} onChange={this.changeOctober} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Nov</span>
          <input type="text" className="form-control" value={november} onChange={this.changeNovember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Dec</span>
          <input type="text" className="form-control" value={december} onChange={this.changeDecember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jan</span>
          <input type="text" className="form-control" value={january} onChange={this.changeJanuary} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Feb</span>
          <input type="text" className="form-control" value={february} onChange={this.changeFebruary} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Mar</span>
          <input type="text" className="form-control" value={march} onChange={this.changeMarch} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Apr</span>
          <input type="text" className="form-control" value={april} onChange={this.changeApril} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>May</span>
          <input type="text" className="form-control" value={may} onChange={this.changeMay} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jun</span>
          <input type="text" className="form-control" value={june} onChange={this.changeJune} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        {forecastid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {forecastid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.updateClick(forecastid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>


</div>
  )
}
  }




